The person's name.
